import React, { useContext, useState } from "react";
import styles from "./EmailResetPassword.module.scss";
import axios from "axios";
//import { UserContext } from "../../context/UserContext";
import { toast } from "react-toastify";
import { MdOutlineMail } from "react-icons/md";
import useModal from "../../../hooks/useModal";
import Modal from "../../UiComponents/modals/Modal";
import Button from "../../UiComponents/Button";

const EmailResetPassword = ({ email, userLogin }) => {
  //MODAL
  const { isShowing, toggle } = useModal();

  axios.defaults.withCredentials = true;

const submitFormsForgotPassword = async (email) => {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_API_URL}api/sendEmailForNewPass`,
      { userMail: email }
    );

    // ✅ Succès
    if (response.status === 200) {
      toast.success(
        "Un email de réinitialisation a été envoyé à l'utilisateur"
      );
      toggle(); // 👉 ferme la modale UNIQUEMENT en cas de succès
    } else {
      toast.error("Une erreur s'est produite lors de l'envoi de l'email");
    }
  } catch (error) {
    console.error("Erreur envoi email reset :", error);
    toast.error("Une erreur s'est produite lors de l'envoi de l'email");
  }
};


  return (
    <div className={styles.email}>
      <MdOutlineMail
        className={styles.email}
        style={{ fontSize: "25px", cursor: "pointer" ,  color: "var(--color-primary)" }}
        onClick={toggle}
         title="Envoyer un email de réinitialisation"
      />
      <Modal isShowing={isShowing} hide={toggle}>
        <div className={styles.content}>
          <h3>
            Souhaitez-vous envoyer un email de réinistiatisation à{" "}
            <span>{userLogin}</span>
          </h3>
          <h3>
            Adresse email de l'utilisateur : <span>{email}</span>
          </h3>
          <div className={styles.containerBtn}>
            <Button onPress={toggle} styles={"btnDelete"} text={"Annuler"} />
            <Button
              onPress={() => submitFormsForgotPassword(email)}
              styles={"btnValidation"}
              text={"Envoi l'email"}
            />
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default EmailResetPassword;
